export enum NotificationType {
    CONFIRMATION = 'CONFIRMATION',
    CANCELLATION = 'CANCELLATION',
    REMINDER = 'REMINDER',
    ONLINE_LINK = 'ONLINE_LINK',
    RESCHEDULED = 'RESCHEDULED',
}

export enum NotificationCategory {
    APPOINTMENT = 'APPOINTMENT',
    SCHEDULE = 'SCHEDULE',
}

export interface NotificationSetting {
    category: NotificationCategory; // APPOINTMENT, SCHEDULE
    type: NotificationType; // CONFIRMATION, CANCELLATION, REMINDER, ONLINE_LINK, FEEDBACK, RESCHEDULED
    is_deactivated: boolean;
}
